import React from "react";
import { DataTable, SearchPropTypes } from "MODULES/shared/components";
import { useCurrentUser } from "APP_ROOT/hooks";
import _ from "lodash";
import Row from "./Row";

export default function Table({ isLoading, pageActions, results }) {
  const currentUser = useCurrentUser();
  const hasWareHouses = _.get(currentUser, "tenant.ware_houses", []).length > 0;
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th />
        <th />
        <th>SO #</th>
        <th>Date Created</th>
        <th>Customer</th>
        <th>Seller</th>
        <th>Inv #</th>
        <th>Paid Date</th>
        <th>Customer PO #</th>
        <th>Store Owner</th>
        <th>Store Loc</th>
        <th>Location</th>
        {hasWareHouses && <th>WH #</th>}
        <th>Warnings</th>
        <th>Part #</th>
        <th>Sell As Alt</th>
        <th>Serial #</th>
        <th>CD</th>
        <th className="text-center">Qty</th>
        <th className="text-center">Exch</th>
        <th className="text-right">Cost Per Unit</th>
        <th className="text-right">Sales EA/Exch Fee</th>
        <th className="text-right">Outright Value</th>
        <th className="text-right">Profit</th>
        <th>Status</th>
        <th>Note</th>
      </DataTable.Head>
      <DataTable.Body>{results.map(Row)}</DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  ...SearchPropTypes
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Search/Table.jsx